export const ROUTES = {
  // Public vitrine
  HOME: '/',
  FONCTIONNALITES: '/fonctionnalites',
  FONCTIONNALITES_SITE_WEB: '/fonctionnalites/site-web',
  TARIFS: '/tarifs',
  CONTACT: '/contact',
  BLOG: '/blog',
  ARTICLE: '/blog/:slug',
  COMMENT_CA_MARCHE: '/comment-ca-marche',
  SUPPORT: '/support',
  PLV: '/plv',

  // Annuaire public
  CLUBS: '/clubs',
  CLUB_PROFILE: '/clubs/:id',
  // ⚠️ Jamais sous /blog/... : ARTICLE ('/blog/:slug') capturerait l'URL.
  CLUB_BLOG: '/clubs/:id/blog',
  SEARCH_CONCOURS: '/concours',
  CONCOUR: '/concours/:id',
  CONCOURS_RESULTATS: '/concours/:id/resultats',
  SEARCH_ORGANIZATIONS: '/organisateurs',
  ORGANIZATION_PROFILE: '/organisateurs/:id',
  ORGANIZATION_BLOG: '/organisateurs/:id/blog',

  // Parrainage
  PARRAINAGE: '/parrainage',
  PARRAINAGE_ORGANISATEUR: '/parrainage/organisateur',
  PARRAINAGE_CLUB: '/parrainage/club',
  PARRAINAGE_JOUEUR: '/parrainage/joueur',

  // Auth
  LOGIN: '/connexion',
  REGISTER: '/inscription',
  FORGOT_PASSWORD: '/mot-de-passe-oublie',
  AUTH_CALLBACK: '/auth/callback',
  IMPERSONATE_CALLBACK: '/auth/impersonate',

  // Espace personnel (redirecte vers le bon dashboard selon le rôle)
  ROLE_LANDING: '/mon-espace',
  REGISTER_CONCOUR: '/concours/:id/inscription',

  // Dashboard Club

  // Dashboard Joueur
  MEMBER_PROFILE: '/profil/:id',

  // Demo simulateur interactif
  DEMO: '/demo',
  DEMO_CLUB: '/demo-club',
  DEMO_ORGANIZER: '/demo-organisateur',

  // Légal
  MENTIONS_LEGALES: '/mentions-legales',
  CGU_CGV: '/cgu-cgv',
  POLITIQUE_RGPD: '/politique-rgpd',
  COOKIES: '/cookies',
  A_PROPOS: '/a-propos',

  // SaaS system pages
  MAINTENANCE: '/maintenance',
  INSCRIPTIONS_FERMEES: '/inscriptions-fermees',
} as const;
